import {
  basicInformations,
  projectMaterials,
  additionalRequirements,
  submit,
} from './overviewSteps/';

const [firstBasicInformationStep] = basicInformations.onboardingSteps;

export const initialState = {
  freelancersPage: {
    preFilter: {},
  },
  currentStep: firstBasicInformationStep.key,
  isFetching: false,
  isSavingProject: false,
  isFetchingFreelancers: false,
  basic_information: basicInformations,
  project_materials: projectMaterials,
  additional_requirements: additionalRequirements,
  submit,
  budget: 0,
  minBudget: 0,
  maxBudget: 0,
  recommendedBudget: 0,
};



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/initialState.js